// Library Methods
import React from 'react';
import PropTypes from 'prop-types';
import { Route, Redirect } from 'react-router-dom';

// A wrapper for <Route> that redirects to the login
// screen if you're not yet authenticated.
function AuthRoute({ children, isLoggedIn, ...rest }) {
    // const isLoggedIn = getFromLocalStorage(
    //     LOCAL_STORAGE_FIELD_NAMES.IS_LOGGED_IN
    // );

    return (
        <Route
            {...rest}
            render={({ location }) =>
                isLoggedIn ? (
                    children
                ) : (
                    <Redirect
                        to={{
                            pathname: '/login',
                            state: { from: location },
                        }}
                    />
                )
            }
        />
    );
}

AuthRoute.propTypes = {
    children: PropTypes.node,
    isLoggedIn: PropTypes.bool,
};

export default AuthRoute;
